// Static list of world nationalities (demonyms) used by the Nationality
// autocomplete on the Add/Edit Member form. The top three are pinned for
// the local context — every other entry is alphabetical.
const PRIORITY = ['Eritrean', 'Ethiopian', 'Zambian'];

const REST = [
  'Afghan', 'Albanian', 'Algerian', 'American', 'Andorran', 'Angolan', 'Antiguan and Barbudan',
  'Argentine', 'Armenian', 'Australian', 'Austrian', 'Azerbaijani',
  'Bahamian', 'Bahraini', 'Bangladeshi', 'Barbadian', 'Belarusian', 'Belgian', 'Belizean',
  'Beninese', 'Bhutanese', 'Bolivian', 'Bosnian', 'Botswanan', 'Brazilian', 'British',
  'Bruneian', 'Bulgarian', 'Burkinabé', 'Burmese', 'Burundian',
  'Cambodian', 'Cameroonian', 'Canadian', 'Cape Verdean', 'Central African', 'Chadian',
  'Chilean', 'Chinese', 'Colombian', 'Comoran', 'Congolese', 'Costa Rican', 'Croatian',
  'Cuban', 'Cypriot', 'Czech',
  'Danish', 'Djiboutian', 'Dominican', 'Dutch',
  'Ecuadorian', 'Egyptian', 'Emirati', 'Equatorial Guinean', 'Estonian', 'Eswatini',
  'Fijian', 'Filipino', 'Finnish', 'French',
  'Gabonese', 'Gambian', 'Georgian', 'German', 'Ghanaian', 'Greek', 'Grenadian',
  'Guatemalan', 'Guinean', 'Guinea-Bissauan', 'Guyanese',
  'Haitian', 'Honduran', 'Hungarian',
  'Icelandic', 'Indian', 'Indonesian', 'Iranian', 'Iraqi', 'Irish', 'Israeli', 'Italian',
  'Ivorian',
  'Jamaican', 'Japanese', 'Jordanian',
  'Kazakh', 'Kenyan', 'Kiribati', 'Kosovan', 'Kuwaiti', 'Kyrgyz',
  'Laotian', 'Latvian', 'Lebanese', 'Liberian', 'Libyan', 'Liechtensteiner',
  'Lithuanian', 'Luxembourgish',
  'Macedonian', 'Madagascan', 'Malawian', 'Malaysian', 'Maldivian', 'Malian', 'Maltese',
  'Marshallese', 'Mauritanian', 'Mauritian', 'Mexican', 'Micronesian', 'Moldovan',
  'Monégasque', 'Mongolian', 'Montenegrin', 'Moroccan', 'Mozambican',
  'Namibian', 'Nauruan', 'Nepali', 'New Zealander', 'Nicaraguan', 'Nigerien', 'Nigerian',
  'North Korean', 'Norwegian',
  'Omani',
  'Pakistani', 'Palauan', 'Palestinian', 'Panamanian', 'Papua New Guinean', 'Paraguayan',
  'Peruvian', 'Polish', 'Portuguese',
  'Qatari',
  'Romanian', 'Russian', 'Rwandan',
  'Saint Lucian', 'Salvadoran', 'Samoan', 'San Marinese', 'Saudi', 'Senegalese',
  'Serbian', 'Seychellois', 'Sierra Leonean', 'Singaporean', 'Slovak', 'Slovenian',
  'Solomon Islander', 'Somali', 'South African', 'South Korean', 'South Sudanese',
  'Spanish', 'Sri Lankan', 'Sudanese', 'Surinamese', 'Swazi', 'Swedish', 'Swiss', 'Syrian',
  'Taiwanese', 'Tajik', 'Tanzanian', 'Thai', 'Timorese', 'Togolese', 'Tongan',
  'Trinidadian and Tobagonian', 'Tunisian', 'Turkish', 'Turkmen', 'Tuvaluan',
  'Ugandan', 'Ukrainian', 'Uruguayan', 'Uzbek',
  'Vanuatuan', 'Vatican', 'Venezuelan', 'Vietnamese',
  'Yemeni',
  'Zimbabwean',
];

// Final list = priority three (in order) + alphabetised rest.
export const WORLD_NATIONALITIES = [
  ...PRIORITY,
  ...REST.slice().sort((a, b) => a.localeCompare(b)),
];

// Merge the static list with anything the admin has typed before (de-duped,
// case-insensitive). Priority three stay at the top; user-entered values that
// aren't already known append after the static list.
export function mergeNationalities(userEntries = []) {
  const seen = new Set(WORLD_NATIONALITIES.map(n => n.toLowerCase()));
  const extras = [];
  userEntries.forEach(n => {
    const v = String(n || '').trim();
    if (!v) return;
    if (!seen.has(v.toLowerCase())) {
      seen.add(v.toLowerCase());
      extras.push(v);
    }
  });
  return [...WORLD_NATIONALITIES, ...extras.sort((a, b) => a.localeCompare(b))];
}
